import React, {useState} from 'react';
import './App.css';
import Partidos from './components/Partidos';

function range(size, startAt = 0) {
  return [...Array(size).keys()].map(i => i + startAt);
}

function App() {
  const [dia, setDia] = useState("17")
  const numbers = range(2, 17)
  console.log(numbers)
  return (
    <div className="App">
      <div className="fechas">
        {
          numbers.map(number => <div key={number} className={`fecha-pendiente ${parseInt(dia) === number ? 'activo': ''}`} onClick={() => setDia(`${number}`)}>{number}</div>)
        }
      </div>
      <Partidos dia={dia} />
    </div>
  );
}

export default App;
